module.exports = __webpack_public_path__ + "static/dp-logo-large-black-3aa83287039d13f79548e1d003aca1e2.svg";